import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=28d86c50&scoped=true"
import script from "./ColorSwatch.vue?vue&type=script&lang=js"
export * from "./ColorSwatch.vue?vue&type=script&lang=js"
import style0 from "./ColorSwatch.vue?vue&type=style&index=0&id=28d86c50&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d86c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28d86c50')) {
      api.createRecord('28d86c50', component.options)
    } else {
      api.reload('28d86c50', component.options)
    }
    module.hot.accept("./ColorSwatch.vue?vue&type=template&id=28d86c50&scoped=true", function () {
      api.rerender('28d86c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/ColorSwatch.vue"
export default component.exports